/* unplugin-vue-components disabled */import script from "./peoplepage.vue?vue&type=script&setup=true&lang=ts"
export * from "./peoplepage.vue?vue&type=script&setup=true&lang=ts"

import "./peoplepage.vue?vue&type=style&index=0&id=3c07fdc4&lang=less&scoped=true"

import exportComponent from "D:\\openclawprogram\\sdjk123-vue - Copy (2)\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c07fdc4"]])

export default __exports__